<template>
  <div class="ws-modal">
    <div class="ws-modal__form">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">{{$t('История назначения Главных экспертов')}}</h2>
      </header>
      <div class="ws-modal__content">
        <ws-list-view class="ws-main_expert_history-table is-table is-small"
                      :bordered="true"
                      :data="history || []"
                      :header="true"
                      :detailed="false"
                      :columns="columns"
                      :skeleton="isExamPending"
                      :placeholder="'Ничего не найдено.'">
          <template slot-scope="props">
            <ws-list-view-item-column data-id="time-formatter-column"><ws-time-formatter :date="props.row.created_at" format="LL" /></ws-list-view-item-column>
            <ws-list-view-item-column data-id="main-expert-column">
              <div>
                <strong>{{getMainExpertFullName(props.row.additional_info.main_expert)}}</strong><br>
                {{getMainExpertEmail(props.row.additional_info.main_expert)}}
              </div>
            </ws-list-view-item-column>
            <ws-list-view-item-column data-id="exam-action-column">
              <strong :class="{
                'has-text-danger': props.row.action === 'remove' || props.row.action === 'reject',
                'has-text-success': props.row.action === 'accept',
                'has-text-warning': props.row.action === 'request' || props.row.action === 'add',
              }">{{$t(`exam.action.${props.row.action}`)}}</strong>
            </ws-list-view-item-column>
            <ws-list-view-item-column data-id="user-column">
              <div>
                <strong>{{getUserFullName(props.row.user_id)}}</strong><br>
                {{getUserEmail(props.row.user_id)}}
              </div>
            </ws-list-view-item-column>
          </template>
          <template slot="skeleton">
            <ws-list-view-skeleton-item :height="'50px'" :boxCount="0" />
            <ws-list-view-skeleton-item :height="'100px'" :boxCount="4" :boxHeights="['100px', '100px', '100px', '100px']" />
          </template>
        </ws-list-view>
        <b-loading :is-full-page="false" :active="isExpertsPending || isUsersPending"></b-loading>
      </div>
    </div>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
const nullGuid = '00000000-0000-0000-0000-000000000000'
export default {
  name: 'WsMainExpertHistory',
  components: {},
  props: {
    examGuid: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      columns: [
        {
          field: 'created_at',
          label: 'Дата'
        },
        {
          field: 'additional_info.main_expert',
          label: 'Главный эксперт'
        },
        {
          field: 'action',
          label: 'Операция'
        },
        {
          field: 'user_id',
          label: 'Исполнитель'
        }
      ],
      nullGuid,
      history: null
    }
  },
  computed: {
    ...mapState('refbook/experts', {
      isExpertsPending: 'isFindPending'
    }),
    ...mapState('esatk/users', {
      isUsersPending: 'isGetPending'
    }),
    ...mapGetters('refbook/experts', {
      getExpertById: 'get'
    }),
    ...mapGetters('esatk/users-list', {
      getUserById: 'get'
    }),
    ...mapState('exams', {
      isExamPending: 'isGetPending'
    }),
    ...mapGetters('exams', {
      getExamById: 'get'
    })
  },
  methods: {
    ...mapActions('refbook/experts', {
      findExperts: 'find'
    }),
    ...mapActions('esatk/users-list', {
      findUsers: 'find'
    }),
    ...mapActions('exams', {
      findExam: 'get',
      getExam: 'getExam'
    }),
    getMainExpertFullName (guid) {
      if (guid === nullGuid) {
        return this.$t('Без указания кандидатуры')
      } else {
        const expert = this.getExpertById(guid)
        if (expert) {
          return `${expert.user_info.last.display} ${expert.user_info.first.display} ${expert.user_info.middle.display}`
        }
      }
    },
    getMainExpertEmail (guid) {
      if (guid === nullGuid) {
        return ''
      } else {
        const expert = this.getExpertById(guid)
        if (expert) {
          return expert.user_info.email
        }
      }
    },
    getUserFullName (guid) {
      const user = this.getUserById(guid)
      if (user) {
        return `${user.last.display} ${user.first.display} ${user.middle.display}`
      }
    },
    getUserEmail (guid) {
      const user = this.getUserById(guid)
      if (user) {
        return user.email
      }
    },
    close () {
      this.$parent.close()
    }
  },
  async mounted () {
    const exam = await this.getExam(this.examGuid)
    this.history = exam.logging
    if (this.history && this.history.length) {
      const expertGuids = [...new Set(
        this.history.map(h => h.additional_info.main_expert).filter(guid => guid !== nullGuid)
      )]
      const userGuids = [...new Set(this.history.map(h => h.user_id))]

      if (userGuids.length || expertGuids.length) {
        await Promise.all([
          expertGuids.length && this.findExperts({
            query: {
              guids: expertGuids
            }
          }),
          this.findUsers({
            guid: userGuids.map(userId => (userId)),
            mode: ['ext/profile']
          })
        ])
      }
    }
  }
}
</script>
